// custom typefaces
// import "@fontsource-variable/montserrat"
// import "@fontsource/merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

// import "@fontsource/ibm-plex-sans"

require("./src/my-prism-theme.css")

// const theme =
//   localStorage.getItem("theme") === "reversed"
//     ? "prismjs/themes/prism.css"
//     : "prismjs/themes/prism-tomorrow.css"

// require(theme)
